export default "__VITE_ASSET__DjgcWDUf__"